import customProperty from 'fela-plugin-custom-property';
import arrayReduce from 'fast-loops/lib/arrayReduce';

var placeholderPrefixes = ['::-webkit-input-placeholder', '::-moz-placeholder', ':-ms-input-placeholder', ':-moz-placeholder', '::placeholder'];

export default function placeholderPrefixer() {
  return customProperty({
    '::placeholder': function placeholder(value) {
      return arrayReduce(placeholderPrefixes, function (style, prefix) {
        style[prefix] = value;
        return style;
      }, {});
    }
  });
}